import { render, staticRenderFns } from "./IQUserPrompt.vue?vue&type=template&id=6dacc98d&scoped=true"
import script from "./IQUserPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./IQUserPrompt.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQUserPrompt.vue?vue&type=style&index=0&id=6dacc98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dacc98d",
  null
  
)

export default component.exports